<template>
    <div class="content-manage-video-info">
        <video :src="contentInfo.content" controls class="play-video"></video>
        <div class="content-info">
            <div class="base-info">
                <a @click="getUrl(contentInfo.sourceUrl)" class="source" target="_blank" :style="{'opacity': contentInfo.source ? '1' : '0'}">来源：{{contentInfo.source}}</a>
                <span class="time">{{$moment(contentInfo.releaseTime).format("YYYY-MM-DD HH:mm")}}</span>
            </div>
            <p class="content-title">{{contentInfo.title}}</p>
            <div class="other-info">
                <span class="author">责任编辑:{{contentInfo.author}}</span>
                 <span v-if="contentInfo.labelId == 1 || contentInfo.labelId == 2" :class="[{'label': contentInfo.labelId == 1 },{'policy_label': contentInfo.labelId == 2}]">{{contentInfo.labelName}}</span>
                <span class="label" v-if="contentInfo.labelId !== 1 && contentInfo.labelId !== 2" :style="{color: currentLabelColor.color,backgroundColor: currentLabelColor.bg}">{{contentInfo.labelName}}</span>
            </div>
            <div class="video-introduce">
                <p class="video-introduce-title">简介</p>
                <p class="video-introduce-info">{{contentInfo.videoNtroduction}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    import { Toast } from 'mint-ui';
    export default{
        name: 'videoInfo',
        props: ['contentInfo', 'currentLabelColor'],
        methods: {
            getUrl(url) {
                console.log('视频类型文章：url',url);
                if(url.length > 0) {
                    return url;
                } else {
                    Toast('链接无效');
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .play-video{
        max-width: 100%;
        min-width: 100%;
        width: 100%;
        height: 420px;
    }
    .content-info{
        line-height: normal;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        padding: 30px;
        .base-info{
            display: flex;
            justify-content: space-between;
            font-size: 24px;
            margin-bottom: 50px;
            .source{
                color: #3576E0;
            }
            .time{
                color: #999999;
            }
        }
        .content-title{
            color: #333333;
            font-size: 32px;
            margin-bottom: 20px;
            font-weight: bold;
        }
        .other-info{
            display: flex;
            justify-content: space-between;
            font-size: 24px;
            margin-bottom: 50px;
            align-items: center;
            .author{
                color: #3576E0;
            }
            //医疗政策 1
            .label{
                padding: 5px 8px;
                color: #FF9F07;
                background-color: #FFF3CB;
                border-radius: 4px;
            }
            //政策解读 2
            .policy_label {
                padding: 5px 8px;
                color: #3576E0;
                background-color: #D6EDFF;
                border-radius: 4px;
            }
        }
        .video-introduce{
            .video-introduce-title{
                border-left: 5px solid #3576E0;
                padding-left: 10px;
                color: #333333;
                font-size: 30px;
                line-height: 30px;
                margin-bottom: 45px;
            }
            .video-introduce-info{
                color: #333333;
                font-size: 28px;
                text-indent: 52px;
            }
        }
    }
</style>